import * as React from 'react';

import { IProvisioningStep } from '../../../Common/ProvisioningModels/ProvisioningStatus';

import * as Styled from './provisioningDetail.styled';

const statusColorMap: Record<string, string> = {
  Succeeded: '#107c10',
  Failed: '#d13438',
  PartiallySucceeded: '#c19c00',
  PipelineRunning: '#0078d4',
  Info: '#616161',
};

function getStatusColor(status: string): string {
  return statusColorMap[status] || '#616161';
}

interface ProvisioningTimelineProps {
  steps: IProvisioningStep[];
}

export function ProvisioningTimeline({ steps }: ProvisioningTimelineProps): React.ReactElement {
  return (
    <Styled.TimelineContainer>
      {steps.map((step, index) => (
        <Styled.TimelineItem key={index}>
          <Styled.TimelineIndicator>
            <Styled.TimelineDot color={getStatusColor(step.status)} />
            {index < steps.length - 1 && <Styled.TimelineLine className="timeline-line" />}
          </Styled.TimelineIndicator>
          <Styled.TimelineContent>
            <Styled.StepName>{step.name}</Styled.StepName>
            {step.message && <Styled.StepMessage>{step.message}</Styled.StepMessage>}
          </Styled.TimelineContent>
        </Styled.TimelineItem>
      ))}
    </Styled.TimelineContainer>
  );
}
